/* Satin Curl v2 — animations, interactions et panier latéral.
Vanilla JS, sans dépendance. Respecte prefers-reduced-motion et le bouton « Réduire les animations ». */
(function () {
'use strict';
if (window.__satinCurl) return;
window.__satinCurl = true;

var root = document.documentElement;
var reduceMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
var fineMQ = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
function reduced() { return reduceMQ.matches || root.classList.contains('sc-no-motion'); }
function $(s, c) { return (c || document).querySelector(s); }
function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
function lerp(a, b, t) { return a + (b - a) * t; }
var raf = window.requestAnimationFrame.bind(window);

var money = (function () {
var f;
try { f = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }); }
catch (e) { f = null; }
return function (cents) {
var v = (cents || 0) / 100;
return f ? f.format(v) : v.toFixed(2).replace('.', ',') + ' €';
};
})();

function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}

function productData() {
var el = document.getElementById('sc-product-data');
if (!el) return null;
if (el._data) return el._data;
try { el._data = JSON.parse(el.textContent); return el._data; } catch (e) { return null; }
}

/* Anime un montant affiché (compteur fluide) */
function tweenMoney(el, to) {
if (!el) return;
var from = parseInt(el.getAttribute('data-cents') || to, 10);
el.setAttribute('data-cents', to);
if (reduced() || from === to) { el.textContent = money(to); return; }
var t0 = performance.now(), d = 520;
(function step(t) {
var k = clamp((t - t0) / d, 0, 1);
k = 1 - Math.pow(1 - k, 3);
el.textContent = money(Math.round(lerp(from, to, k)));
if (k < 1) raf(step);
})(t0);
}

/* Remplace un texte avec un petit effet de défilement vertical */
function rollText(el, text) {
if (!el || el.textContent === text) return;
if (reduced()) { el.textContent = text; return; }
el.classList.remove('sc-roll'); void el.offsetWidth;
el.textContent = text;
el.classList.add('sc-roll');
}

if (store('sc_motion') === 'off') root.classList.add('sc-no-motion');
function syncMotionToggles() {
$$('[data-sc-motion-toggle]').forEach(function (b) {
var off = root.classList.contains('sc-no-motion');
b.setAttribute('aria-pressed', off ? 'true' : 'false');
b.textContent = off ? 'Réactiver les animations' : 'Réduire les animations';
});
}

var snow = (function () {
var canvas, ctx, flakes = [], id = 0, w = 0, h = 0, dpr = 1, running = false, sprites = [];
var scrollY = 0, wind = 0, windTarget = 0;
var LAYERS = [
{ n: 0.45, r: [0.6, 1.2], v: [0.15, 0.35], a: [0.25, 0.45], p: 0.05 },
{ n: 0.35, r: [1.2, 2.2], v: [0.35, 0.65], a: [0.4, 0.65], p: 0.12 },
{ n: 0.20, r: [2.4, 4.2], v: [0.7, 1.15], a: [0.5, 0.8], p: 0.25 }
];
function sprite(r) {
var c = document.createElement('canvas'), s = Math.ceil(r * 4) * 2;
c.width = c.height = s;
var g = c.getContext('2d'), gr = g.createRadialGradient(s / 2, s / 2, 0, s / 2, s / 2, s / 2);
gr.addColorStop(0, 'rgba(255,255,255,1)');
gr.addColorStop(0.28, 'rgba(236,240,246,.95)');
gr.addColorStop(0.55, 'rgba(176,186,200,.45)');
gr.addColorStop(1, 'rgba(176,186,200,0)');
g.fillStyle = gr; g.fillRect(0, 0, s, s);
return c;
}
function rnd(a) { return a[0] + Math.random() * (a[1] - a[0]); }
function make(layer, anywhere) {
var L = LAYERS[layer];
return { l: layer, x: Math.random() * w, y: anywhere ? Math.random() * h : -12, r: rnd(L.r), v: rnd(L.v), a: rnd(L.a), d: Math.random() * 6.28, s: 0.004 + Math.random() * 0.01 };
}
function size() {
dpr = Math.min(window.devicePixelRatio || 1, 2);
w = window.innerWidth; h = window.innerHeight;
canvas.width = w * dpr; canvas.height = h * dpr;
canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
var total = Math.round(clamp(w / 14, 26, 110) * (fineMQ.matches ? 1 : 0.7));
flakes = [];
LAYERS.forEach(function (L, i) { for (var k = 0; k < Math.round(total * L.n); k++) flakes.push(make(i, true)); });
}
function tick() {
ctx.clearRect(0, 0, w, h);
wind = lerp(wind, windTarget, 0.02);
for (var i = 0; i < flakes.length; i++) {
var f = flakes[i], L = LAYERS[f.l];
f.d += f.s;
f.y += f.v;
f.x += Math.sin(f.d) * 0.3 * (f.l + 1) + wind * (f.l + 1) * 0.35;
var py = (f.y - scrollY * L.p) % (h + 24);
if (py < -12) py += h + 24;
if (f.x < -20) f.x = w + 10; else if (f.x > w + 20) f.x = -10;
if (f.y > h + 12 + scrollY * L.p) { flakes[i] = make(f.l, false); flakes[i].y = scrollY * L.p - 10; continue; }
var sz = f.r * 4;
ctx.globalAlpha = f.a;
ctx.drawImage(sprites[f.l], f.x - sz, py - sz, sz * 2, sz * 2);
}
ctx.globalAlpha = 1;
id = raf(tick);
}
function start() {
if (running || reduced()) return;
if (!canvas) {
canvas = document.createElement('canvas');
canvas.className = 'sc-snow';
canvas.setAttribute('aria-hidden', 'true');
document.body.appendChild(canvas);
ctx = canvas.getContext('2d');
sprites = [sprite(1), sprite(1.6), sprite(3)];
window.addEventListener('resize', function () { if (running) size(); });
window.addEventListener('scroll', function () { scrollY = window.scrollY; }, { passive: true });
document.addEventListener('pointermove', function (e) { windTarget = (e.clientX / (w || 1) - 0.5) * 1.2; }, { passive: true });
}
canvas.hidden = false;
size();
running = true;
id = raf(tick);
}
function stop() {
running = false;
cancelAnimationFrame(id);
if (canvas) { ctx.clearRect(0, 0, w, h); canvas.hidden = true; }
}
document.addEventListener('visibilitychange', function () {
if (document.hidden) { if (running === true) { cancelAnimationFrame(id); running = 'paused'; } }
else if (running === 'paused') { running = true; id = raf(tick); }
});
return { start: start, stop: stop };
})();

function splitWords(scope) {
$$('[data-sc-split]:not([data-split-done])', scope).forEach(function (el) {
el.setAttribute('data-split-done', '');
var i = 0;
(function walk(node) {
Array.prototype.slice.call(node.childNodes).forEach(function (n) {
if (n.nodeType === 3) {
var frag = document.createDocumentFragment();
n.nodeValue.split(/(\s+)/).forEach(function (part) {
if (!part) return;
if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
var o = document.createElement('span'); o.className = 'sc-w';
var s = document.createElement('span'); s.className = 'sc-w__i'; s.style.setProperty('--i', i++); s.textContent = part;
o.appendChild(s); frag.appendChild(o);
});
node.replaceChild(frag, n);
} else if (n.nodeType === 1 && !n.classList.contains('sc-w')) walk(n);
});
})(el);
});
}

function initReveal(scope) {
splitWords(scope);
var els = $$('[data-sc-reveal]:not(.is-in), [data-sc-split]:not(.is-in), [data-sc-unmask]:not(.is-in)', scope);
if (!els.length) return;
if (reduced() || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (en) {
if (en.isIntersecting) { (en.target._scT || en.target).classList.add('is-in'); io.unobserve(en.target); }
});
}, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
els.forEach(function (e) {
var o = e;
if (e.hasAttribute('data-sc-unmask') && e.parentElement) { o = e.parentElement; o._scT = e; }
io.observe(o);
});
function sweep() {
var vh = window.innerHeight || document.documentElement.clientHeight;
if (!vh) return;
els.forEach(function (e) {
if (e.classList.contains('is-in')) return;
var r = (e.hasAttribute('data-sc-unmask') && e.parentElement ? e.parentElement : e).getBoundingClientRect();
if (r.height && r.top < vh * 0.92 && r.bottom > 0) e.classList.add('is-in');
});
}
raf(sweep);
window.addEventListener('load', sweep, { once: true });
setTimeout(sweep, 1200);
}

function initParallax() {
var items = $$('[data-sc-parallax]');
if (!items.length || reduced()) return;
var visible = new Set(), ticking = false;
var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); }); request(); }, { rootMargin: '20% 0px' });
items.forEach(function (el) { io.observe(el); });
function update() {
ticking = false;
if (reduced()) return;
var vh = window.innerHeight;
visible.forEach(function (el) {
var r = el.getBoundingClientRect();
var p = ((r.top + r.height / 2) - vh / 2) / vh;
var k = parseFloat(el.getAttribute('data-sc-parallax')) || 0.1;
el.style.setProperty('--sc-py', (p * k * -100).toFixed(2) + 'px');
});
}
function request() { if (!ticking) { ticking = true; raf(update); } }
window.addEventListener('scroll', request, { passive: true });
window.addEventListener('resize', request);
request();
}

function initTilt() {
if (!fineMQ.matches) return;
$$('[data-sc-tilt]').forEach(function (el) {
var max = parseFloat(el.getAttribute('data-sc-tilt')) || 6;
el.addEventListener('pointermove', function (e) {
if (reduced()) return;
var r = el.getBoundingClientRect();
var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
el.style.setProperty('--rx', (-y * max).toFixed(2) + 'deg');
el.style.setProperty('--ry', (x * max).toFixed(2) + 'deg');
el.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
el.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
el.classList.add('is-tilting');
});
el.addEventListener('pointerleave', function () {
el.classList.remove('is-tilting');
el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg');
});
});
}

function initButtons() {
if (fineMQ.matches) {
document.addEventListener('pointermove', function (e) {
var b = e.target.closest && e.target.closest('.sc-btn');
if (!b || reduced()) return;
var r = b.getBoundingClientRect();
b.style.setProperty('--bx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
b.style.setProperty('--by', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
if (b.hasAttribute('data-sc-magnetic')) {
b.style.setProperty('--tx', ((e.clientX - r.left - r.width / 2) * 0.18).toFixed(1) + 'px');
b.style.setProperty('--ty', ((e.clientY - r.top - r.height / 2) * 0.25).toFixed(1) + 'px');
}
}, { passive: true });
document.addEventListener('pointerout', function (e) {
var b = e.target.closest && e.target.closest('.sc-btn[data-sc-magnetic]');
if (b && !b.contains(e.relatedTarget)) { b.style.setProperty('--tx', '0px'); b.style.setProperty('--ty', '0px'); }
});
}
document.addEventListener('pointerdown', function (e) {
var b = e.target.closest && e.target.closest('.sc-btn, .sc-tier, .sc-swatch, .sc-chip');
if (!b || reduced()) return;
var r = b.getBoundingClientRect();
var s = document.createElement('span');
var d = Math.max(r.width, r.height) * 1.6;
s.className = 'sc-ripple';
s.style.width = s.style.height = d + 'px';
s.style.left = (e.clientX - r.left - d / 2) + 'px';
s.style.top = (e.clientY - r.top - d / 2) + 'px';
b.appendChild(s);
setTimeout(function () { s.remove(); }, 700);
});
}

function initImages(scope) {
$$('.sc-media img', scope).forEach(function (img) {
var box = img.closest('.sc-media');
if (img.complete && img.naturalWidth) box.classList.add('is-loaded');
else img.addEventListener('load', function () { box.classList.add('is-loaded'); }, { once: true });
});
}

function initHeader() {
var header = $('[data-sc-header]');
if (!header) return;
var last = 0;
var onScroll = function () {
var y = window.scrollY;
header.classList.toggle('is-scrolled', y > 8);
header.classList.toggle('is-hidden', y > 420 && y > last + 4 && !header.classList.contains('menu-open'));
if (y < last - 4) header.classList.remove('is-hidden');
last = y;
};
window.addEventListener('scroll', onScroll, { passive: true });
onScroll();
var burger = $('[data-sc-burger]', header);
var mnav = $('#sc-mnav');
if (burger && mnav) {
burger.addEventListener('click', function () {
var open = burger.getAttribute('aria-expanded') !== 'true';
burger.setAttribute('aria-expanded', open ? 'true' : 'false');
header.classList.toggle('menu-open', open);
if (open) { mnav.hidden = false; raf(function () { mnav.classList.add('is-open'); }); }
else { mnav.classList.remove('is-open'); setTimeout(function () { mnav.hidden = true; }, 400); }
});
$$('a', mnav).forEach(function (a) { a.addEventListener('click', function () { if (burger.getAttribute('aria-expanded') === 'true') burger.click(); }); });
}
}

function flyToCart(img) {
var target = $('[data-sc-cart-open]');
if (!img || !target || reduced()) return Promise.resolve();
var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
if (!a.width) return Promise.resolve();
var c = document.createElement('div');
c.className = 'sc-fly';
c.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
var size = Math.min(a.width, a.height, 260);
c.style.width = c.style.height = size + 'px';
c.style.left = (a.left + a.width / 2 - size / 2) + 'px';
c.style.top = (a.top + a.height / 2 - size / 2) + 'px';
document.body.appendChild(c);
var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
var anim = c.animate([
{ transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '18px' },
{ transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 120) + 'px) scale(.45)', opacity: 1, borderRadius: '40%', offset: 0.55 },
{ transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.06)', opacity: 0.2, borderRadius: '50%' }
], { duration: 820, easing: 'cubic-bezier(.5,0,.2,1)' });
return new Promise(function (res) {
anim.onfinish = function () { c.remove(); target.classList.remove('is-catch'); void target.offsetWidth; target.classList.add('is-catch'); res(); };
});
}

var Cart = (function () {
var drawer, panel, body, foot, lastFocus, cart = null, busy = false, prevKeys = {}, lastPct = 0;
var FREE_SHIP = 4000;

function els() {
drawer = document.getElementById('sc-cart');
if (!drawer) return false;
panel = $('.sc-cart__panel', drawer);
body = $('[data-sc-cart-body]', drawer);
foot = $('[data-sc-cart-foot]', drawer);
return true;
}
function request(url, data) {
var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' };
if (data) { opts.method = 'POST'; opts.body = JSON.stringify(data); }
return fetch(url, opts).then(function (r) {
return r.json().then(function (j) {
if (!r.ok) { throw new Error(j && (j.description || j.message) || 'Une erreur est survenue.'); }
return j;
});
});
}
function load() { return request('/cart.js').then(function (c) { cart = c; render(); return c; }); }
function setCount(n) {
$$('[data-sc-cart-count]').forEach(function (el) {
var changed = el.textContent !== String(n);
el.textContent = n;
el.classList.toggle('is-empty', !n);
if (changed && !reduced()) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
});
}
function skeleton() {
return '<div class="sc-skel" aria-hidden="true"><div class="sc-skel__row"><i></i><div><b></b><b></b></div></div><div class="sc-skel__row"><i></i><div><b></b><b></b></div></div></div><p class="sc-visually-hidden" aria-live="polite">Chargement du panier</p>';
}
function open(notice) {
if (!els()) return;
lastFocus = document.activeElement;
drawer.hidden = false;
document.body.classList.add('sc-lock');
raf(function () { raf(function () {
drawer.classList.add('is-open');
var c = $('[data-sc-cart-close]', drawer);
if (c) c.focus({ preventScroll: true });
}); });
if (notice) toast(notice, 'ok');
if (!cart) { body.innerHTML = skeleton(); load(); }
}
function close() {
if (!els() || drawer.hidden) return;
drawer.classList.remove('is-open');
document.body.classList.remove('sc-lock');
setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, reduced() ? 0 : 560);
if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
}
function add(items) {
return request('/cart/add.js', { items: items }).then(load);
}
function change(key, qty, line) {
if (busy) return Promise.resolve();
busy = true;
if (line) line.classList.add('is-busy');
return request('/cart/change.js', { id: key, quantity: qty }).then(function (c) {
var finish = function () { cart = c; render(); };
if (line && qty === 0 && !reduced()) {
line.style.height = line.offsetHeight + 'px';
line.classList.add('is-leaving');
raf(function () { line.style.height = '0px'; });
setTimeout(finish, 380);
} else finish();
}).catch(function (e) { toast(e.message, 'err'); if (line) line.classList.remove('is-busy'); })
.then(function () { busy = false; });
}
function lineImage(item) {
var src = item.image || (item.featured_image && item.featured_image.url) || '';
if (!src) return '';
var sep = src.indexOf('?') === -1 ? '?' : '&';
return '<img src="' + esc(src + sep + 'width=240') + '" alt="' + esc(item.product_title) + '" width="88" height="88" loading="lazy">';
}
function render() {
if (!els() || !cart) return;
setCount(cart.item_count);
var items = cart.items || [];
if (!items.length) {
body.innerHTML =
'<div class="sc-cart__empty">' +
'<div class="sc-cart__empty-mark" aria-hidden="true"></div>' +
'<p class="sc-cart__empty-title">Votre panier est vide</p>' +
'<p>Le bonnet doublé satin vous attend au chaud.</p>' +
'<a class="sc-btn sc-btn--primary" href="' + esc((productData() || {}).url || '/collections/all') + '"><span class="sc-btn__txt">Découvrir le bonnet</span></a></div>';
foot.hidden = true;
prevKeys = {};
return;
}
var html = '<div class="sc-ship">' + shipping() + '</div><ul class="sc-lines" role="list">';
var keys = {};
items.forEach(function (it, i) {
keys[it.key] = it.quantity;
var isNew = prevKeys[it.key] === undefined;
var bumped = !isNew && prevKeys[it.key] !== it.quantity;
var discounted = it.final_line_price < it.original_line_price;
html +=
'<li class="sc-line' + (isNew ? ' is-new' : '') + '" style="--i:' + i + '" data-key="' + esc(it.key) + '">' +
'<a class="sc-line__img" href="' + esc(it.url) + '">' + lineImage(it) + '</a>' +
'<div class="sc-line__info">' +
'<a class="sc-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
(it.variant_title ? '<span class="sc-line__variant">' + esc(it.variant_title) + '</span>' : '') +
'<div class="sc-qty" role="group" aria-label="Quantité">' +
'<button type="button" data-qty="-1" aria-label="Retirer un article">−</button>' +
'<span class="' + (bumped ? 'sc-roll' : '') + '" aria-live="polite">' + it.quantity + '</span>' +
'<button type="button" data-qty="1" aria-label="Ajouter un article">+</button>' +
'</div></div>' +
'<div class="sc-line__price">' +
(discounted ? '<s>' + money(it.original_line_price) + '</s>' : '') +
'<span class="' + (bumped ? 'sc-roll' : '') + '">' + money(it.final_line_price) + '</span>' +
'<button type="button" class="sc-line__remove" data-remove aria-label="Retirer ' + esc(it.product_title) + ' ' + esc(it.variant_title || '') + '">Retirer</button>' +
'</div></li>';
});
prevKeys = keys;
html += '</ul>' + upsell();
body.innerHTML = html;

var saved = cart.original_total_price - cart.total_price;
var linesEl = $('[data-sc-cart-lines]', foot);
if (!linesEl.firstChild) {
linesEl.innerHTML =
'<div class="sc-sum__row"><span>Sous-total</span><span data-sum="sub"></span></div>' +
'<div class="sc-sum__row sc-sum__row--save" data-save-row hidden><span data-save-title></span><span>−<span data-sum="save"></span></span></div>' +
'<div class="sc-sum__row sc-sum__row--total"><span>Total</span><span data-sum="total"></span></div>';
}
tweenMoney($('[data-sum="sub"]', linesEl), cart.original_total_price);
tweenMoney($('[data-sum="total"]', linesEl), cart.total_price);
var row = $('[data-save-row]', linesEl);
if (saved > 0) {
var titles = {};
items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { titles[a.discount_application.title] = 1; }); });
(cart.cart_level_discount_applications || []).forEach(function (a) { titles[a.title] = 1; });
$('[data-save-title]', row).textContent = Object.keys(titles).join(' · ') || 'Remise';
if (row.hidden) { row.hidden = false; row.classList.remove('sc-pop-in'); void row.offsetWidth; row.classList.add('sc-pop-in'); }
tweenMoney($('[data-sum="save"]', row), saved);
} else row.hidden = true;
foot.hidden = false;
var bar = $('.sc-ship__bar span', body);
if (bar) raf(function () { raf(function () { bar.style.width = bar.getAttribute('data-w') + '%'; }); });
initReveal(body);
}
function shipping() {
var left = FREE_SHIP - cart.total_price;
var pct = Math.min(100, Math.round(cart.total_price / FREE_SHIP * 100));
var msg = left > 0
? (cart.item_count === 1 ? 'Ajoutez un 2<sup>e</sup> bonnet : <strong>livraison offerte</strong> et −25 € sur le lot' : 'Plus que <strong>' + money(left) + '</strong> pour la livraison offerte')
: '<strong>Livraison suivie offerte</strong> sur votre commande';
var html = '<p>' + msg + '</p><div class="sc-ship__bar' + (left <= 0 ? ' is-full' : '') + '" aria-hidden="true"><span style="width:' + lastPct + '%" data-w="' + pct + '"></span></div>';
lastPct = pct;
return html;
}
function upsell() {
var p = productData();
if (!p || !p.variants || !p.variants.length) return '';
var qty = 0;
cart.items.forEach(function (it) { if (it.product_id === p.id) qty += it.quantity; });
if (!qty) return '';
if (qty >= 3) {
return '<div class="sc-upsell sc-upsell--done"><span class="sc-check" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span><p><strong>Offre lot appliquée.</strong> Votre remise de ' + money(p.tiers[2].off) + ' est déduite.</p></div>';
}
var gain = qty === 1 ? p.tiers[1].off : p.tiers[2].off - p.tiers[1].off;
var title = qty === 1 ? 'Ajoutez un 2<sup>e</sup> bonnet' : 'Complétez avec un 3<sup>e</sup> bonnet';
var sub = qty === 1
? 'Lot de 2 : ' + money(p.tiers[1].off) + ' de remise et livraison offerte.'
: 'Lot de 3 : ' + money(gain) + ' de remise en plus (' + money(p.tiers[2].off) + ' au total).';
var avail = p.variants.filter(function (v) { return v.available; });
if (!avail.length) return '';
var chips = avail.map(function (v, i) {
return '<button type="button" class="sc-chip' + (i === 0 ? ' is-active' : '') + '" data-upsell-variant="' + v.id + '" aria-pressed="' + (i === 0) + '">' +
'<span class="sc-chip__dot" style="--c:' + esc(v.color) + '"></span>' + esc(v.title) + '</button>';
}).join('');
var first = avail[0];
return '<div class="sc-upsell" data-sc-reveal>' +
'<span class="sc-upsell__glow" aria-hidden="true"></span>' +
'<div class="sc-upsell__head"><div class="sc-upsell__img"><img src="' + esc(first.image) + '" alt="" width="72" height="72" data-upsell-img></div>' +
'<div><p class="sc-upsell__title">' + title + '</p><p class="sc-upsell__sub">' + sub + '</p></div></div>' +
'<div class="sc-upsell__chips" role="group" aria-label="Couleur du bonnet ajouté">' + chips + '</div>' +
'<button type="button" class="sc-btn sc-btn--gold sc-btn--block" data-upsell-add data-variant="' + first.id + '">' +
'<span class="sc-btn__txt">Ajouter · ' + money(first.price) + ' <em class="sc-upsell__save">−' + money(gain) + ' sur le lot</em></span><span class="sc-spin" aria-hidden="true"></span></button>' +
'</div>';
}
function toast(msg, kind) {
if (!els()) return;
var t = $('[data-sc-cart-toast]', drawer);
if (!t) return;
t.className = 'sc-cart__toast sc-cart__toast--' + (kind || 'err');
t.innerHTML = (kind === 'ok' ? '<span class="sc-check" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>' : '') + '<span>' + esc(msg) + '</span>';
t.hidden = false;
clearTimeout(t._h);
t._h = setTimeout(function () { t.hidden = true; }, kind === 'ok' ? 2600 : 4200);
}
function bind() {
if (!els()) return;
drawer.addEventListener('click', function (e) {
var t = e.target;
if (t.closest('[data-sc-cart-close]') || t.classList.contains('sc-cart__overlay')) { e.preventDefault(); close(); return; }
var line = t.closest('.sc-line');
if (line && t.closest('[data-qty]')) {
var it = cart.items.filter(function (x) { return x.key === line.getAttribute('data-key'); })[0];
if (it) change(it.key, Math.max(0, it.quantity + parseInt(t.closest('[data-qty]').getAttribute('data-qty'), 10)), it.quantity === 1 && t.closest('[data-qty]').getAttribute('data-qty') === '-1' ? line : null);
return;
}
if (line && t.closest('[data-remove]')) { change(line.getAttribute('data-key'), 0, line); return; }
var chip = t.closest('[data-upsell-variant]');
if (chip) {
var p = productData();
var v = p.variants.filter(function (x) { return String(x.id) === chip.getAttribute('data-upsell-variant'); })[0];
$$('[data-upsell-variant]', drawer).forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip); });
var btn = $('[data-upsell-add]', drawer);
if (btn && v) btn.setAttribute('data-variant', v.id);
var img = $('[data-upsell-img]', drawer);
if (img && v && v.image && img.src.indexOf(v.image.split('?')[0]) === -1) {
img.classList.add('is-swap');
setTimeout(function () { img.src = v.image; img.onload = function () { img.classList.remove('is-swap'); }; }, 160);
}
return;
}
var addBtn = t.closest('[data-upsell-add]');
if (addBtn) {
addBtn.classList.add('is-loading');
addBtn.disabled = true;
request('/cart/add.js', { items: [{ id: parseInt(addBtn.getAttribute('data-variant'), 10), quantity: 1 }] })
.then(load)
.then(function () { toast('Bonnet ajouté, remise lot appliquée', 'ok'); })
.catch(function (err) { toast(err.message, 'err'); addBtn.disabled = false; addBtn.classList.remove('is-loading'); });
}
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && drawer && !drawer.hidden) close();
if (e.key === 'Tab' && drawer && !drawer.hidden) {
var f = $$('a[href], button:not([disabled]), input, select', panel).filter(function (x) { return x.offsetParent !== null; });
if (!f.length) return;
if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
}
});
var checkout = $('[data-sc-checkout]', drawer);
if (checkout) checkout.addEventListener('click', function () { checkout.classList.add('is-loading'); });
}
document.addEventListener('click', function (e) {
var t = e.target.closest && e.target.closest('[data-sc-cart-open], a[href="/cart"], a[href$="/cart"]');
if (!t || !document.getElementById('sc-cart')) return;
if (t.closest('#sc-cart')) return;
e.preventDefault();
open();
}, true);
window.addEventListener('pageshow', function (e) { if (e.persisted && els()) { load().catch(function () {}); var c = $('[data-sc-checkout]', drawer); if (c) c.classList.remove('is-loading'); } });
return { init: function () { bind(); if (els()) load().catch(function () {}); }, open: open, close: close, add: add, toast: toast };
})();
window.SatinCart = Cart;

function initProduct() {
var pr = $('[data-sc-product]');
if (!pr) return;
var p = productData();
if (!p) return;
var form = $('[data-sc-form]', pr);
var state = { variant: null, tier: p.tiers[1] ? 2 : 1, slide: 0 };
var initial = new URLSearchParams(location.search).get('variant');
var available = p.variants.filter(function (v) { return v.available; });
state.variant = p.variants.filter(function (v) { return String(v.id) === initial; })[0] || available[0] || p.variants[0];

var slides = $$('[data-sc-slide]', pr);
var thumbs = $$('[data-sc-thumb]', pr);
var dots = $$('[data-sc-dot]', pr);
var stage = $('[data-sc-stage]', pr);
var track = $('[data-sc-track]', pr);
var counter = $('[data-sc-counter]', pr);
var mobile = function () { return window.matchMedia('(max-width: 899px)').matches; };

function go(i, instant) {
if (!slides.length) return;
i = (i + slides.length) % slides.length;
var prev = state.slide;
state.slide = i;
slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.classList.toggle('is-prev', k === prev && k !== i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
if (mobile() && track) {
var sl = slides[i];
track.scrollTo({ left: sl.offsetLeft, behavior: instant || reduced() ? 'auto' : 'smooth' });
}
}
function indexOfImage(src) {
if (!src) return -1;
var base = src.split('?')[0];
for (var k = 0; k < slides.length; k++) if ((slides[k].getAttribute('data-src') || '').split('?')[0] === base) return k;
return -1;
}
thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
$$('[data-sc-nav]', pr).forEach(function (b) { b.addEventListener('click', function () { go(state.slide + parseInt(b.getAttribute('data-sc-nav'), 10)); }); });
if (track) {
var st;
track.addEventListener('scroll', function () {
if (!mobile()) return;
clearTimeout(st);
st = setTimeout(function () {
var i = Math.round(track.scrollLeft / track.clientWidth);
if (i !== state.slide) { state.slide = i; dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); if (counter) counter.textContent = (i + 1) + ' / ' + slides.length; }
}, 60);
}, { passive: true });
}
if (stage && fineMQ.matches) {
stage.addEventListener('pointermove', function (e) {
if (reduced()) return;
var r = stage.getBoundingClientRect();
stage.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
stage.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
stage.classList.add('is-zoom');
});
stage.addEventListener('pointerleave', function () { stage.classList.remove('is-zoom'); });
}
document.addEventListener('keydown', function (e) {
if (!stage || !stage.matches(':hover')) return;
if (e.key === 'ArrowRight') go(state.slide + 1);
if (e.key === 'ArrowLeft') go(state.slide - 1);
});

function selectedColors() {
var rows = $$('[data-sc-unit]', pr);
var ids = rows.slice(0, state.tier).map(function (r) { return parseInt(r.value, 10); });
while (ids.length < state.tier) ids.push(state.variant.id);
return ids;
}
function totalFor(tier) {
var t = p.tiers.filter(function (x) { return x.qty === tier; })[0] || { off: 0 };
var sum = 0;
if (tier === state.tier) {
selectedColors().forEach(function (id) {
var v = p.variants.filter(function (x) { return x.id === id; })[0];
sum += v ? v.price : state.variant.price;
});
} else sum = state.variant.price * tier;
return { full: sum, now: sum - t.off, off: t.off };
}
function renderUnits() {
var box = $('[data-sc-units]', pr);
if (!box) return;
if (state.tier < 2) { box.classList.remove('is-open'); setTimeout(function () { if (state.tier < 2) { box.hidden = true; box.innerHTML = ''; } }, 300); return; }
var prev = $$('[data-sc-unit]', box).map(function (s) { return s.value; });
var html = '<p class="sc-units__label">Une couleur par bonnet, mélange possible</p>';
for (var i = 0; i < state.tier; i++) {
var sel = prev[i] || state.variant.id;
html += '<div class="sc-unit" style="--i:' + i + '"><span>Bonnet ' + (i + 1) + '</span><div class="sc-unit__dots" role="radiogroup" aria-label="Couleur du bonnet ' + (i + 1) + '">' +
p.variants.map(function (v) {
var on = String(v.id) === String(sel);
return '<button type="button" class="sc-unit__dot' + (on ? ' is-active' : '') + '" role="radio" aria-checked="' + on + '" aria-label="' + esc(v.title) + '" title="' + esc(v.title) + '" style="--c:' + esc(v.color) + '" data-unit-pick="' + v.id + '"' + (v.available ? '' : ' disabled') + '></button>';
}).join('') + '</div><input type="hidden" data-sc-unit value="' + sel + '"><em data-unit-name>' + esc((p.variants.filter(function (v) { return String(v.id) === String(sel); })[0] || {}).title || '') + '</em></div>';
}
box.innerHTML = html;
box.hidden = false;
raf(function () { box.classList.add('is-open'); });
}
pr.addEventListener('click', function (e) {
var pick = e.target.closest('[data-unit-pick]');
if (!pick) return;
var row = pick.closest('.sc-unit');
$$('[data-unit-pick]', row).forEach(function (b) { b.classList.toggle('is-active', b === pick); b.setAttribute('aria-checked', b === pick); });
$('[data-sc-unit]', row).value = pick.getAttribute('data-unit-pick');
var v = p.variants.filter(function (x) { return String(x.id) === pick.getAttribute('data-unit-pick'); })[0];
rollText($('[data-unit-name]', row), v ? v.title : '');
update();
});

function update(fromSwatch) {
$$('[data-sc-tier]', pr).forEach(function (card) {
var q = parseInt(card.getAttribute('data-sc-tier'), 10);
var t = totalFor(q);
tweenMoney($('[data-tier-now]', card), t.now);
var full = $('[data-tier-full]', card);
if (full) { full.textContent = t.off ? money(t.full) : ''; full.hidden = !t.off; }
var unitEl = $('[data-tier-unit]', card);
if (unitEl) unitEl.textContent = money(Math.round(t.now / q)) + ' / bonnet';
card.classList.toggle('is-active', q === state.tier);
var input = $('input', card);
if (input) input.checked = q === state.tier;
});
var t = totalFor(state.tier);
$$('[data-sc-price]', pr).forEach(function (el) { tweenMoney(el, state.variant.price); });
$$('[data-sc-atc-total]').forEach(function (el) { tweenMoney(el, t.now); });
$$('[data-sc-color-name]').forEach(function (el) { rollText(el, state.variant.title); });
$$('[data-sc-swatch]', pr).forEach(function (s) {
var on = s.getAttribute('data-sc-swatch') === String(state.variant.id);
s.classList.toggle('is-active', on); s.setAttribute('aria-checked', on ? 'true' : 'false');
});
var ok = state.variant.available;
$$('[data-sc-atc]').forEach(function (b) { b.disabled = !ok; var l = $('[data-sc-atc-label]', b); if (l) l.textContent = ok ? 'Ajouter au panier' : 'Épuisé'; });
var hidden = form && $('input[name="id"]', form);
if (hidden) hidden.value = state.variant.id;
if (history.replaceState) {
try { var u = new URL(location.href); u.searchParams.set('variant', state.variant.id); history.replaceState(null, '', u.toString()); } catch (er) {}
}
}

$$('[data-sc-swatch]', pr).forEach(function (s) {
s.addEventListener('click', function () {
var v = p.variants.filter(function (x) { return String(x.id) === s.getAttribute('data-sc-swatch'); })[0];
if (!v || v === state.variant) return;
state.variant = v;
$$('.sc-unit', pr).forEach(function (row) {
$('[data-sc-unit]', row).value = v.id;
$$('[data-unit-pick]', row).forEach(function (b) { var on = b.getAttribute('data-unit-pick') === String(v.id); b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
var n = $('[data-unit-name]', row); if (n) n.textContent = v.title;
});
var i = indexOfImage(v.image_full);
if (i > -1) go(i);
update(true);
});
});
$$('[data-sc-tier]', pr).forEach(function (card) {
card.addEventListener('click', function (e) {
e.preventDefault();
var q = parseInt(card.getAttribute('data-sc-tier'), 10);
if (q === state.tier) return;
state.tier = q;
renderUnits(); update();
});
});

function addToCart(btn) {
if (btn.classList.contains('is-loading')) return;
btn.classList.add('is-loading');
var err = $('[data-sc-error]', pr); if (err) err.hidden = true;
var counts = {};
selectedColors().forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
var img = $('[data-sc-slide].is-active img', pr) || $('[data-sc-slide] img', pr);
Cart.add(items).then(function () {
btn.classList.remove('is-loading'); btn.classList.add('is-done');
var lbl = state.tier > 1 ? state.tier + ' bonnets ajoutés' : 'Bonnet ajouté';
return flyToCart(img).then(function () { Cart.open(lbl + ' au panier'); });
}).then(function () {
setTimeout(function () { btn.classList.remove('is-done'); }, 1400);
}).catch(function (e) {
btn.classList.remove('is-loading');
btn.classList.add('is-shake'); setTimeout(function () { btn.classList.remove('is-shake'); }, 500);
if (err) { err.textContent = e.message || 'Impossible d’ajouter au panier.'; err.hidden = false; }
});
}
$$('[data-sc-atc]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); addToCart(b); }); });
if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart($('[data-sc-atc]', form)); });

var sticky = $('[data-sc-sticky]');
var mainBtn = $('[data-sc-atc]', pr);
if (sticky && mainBtn && 'IntersectionObserver' in window) {
new IntersectionObserver(function (en) {
var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
sticky.classList.toggle('is-visible', show);
sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
$$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
}).observe(mainBtn);
}

var startIdx = indexOfImage(state.variant.image_full);
go(startIdx > -1 && initial ? startIdx : 0, true);
renderUnits();
update();
}

function init() {
syncMotionToggles();
initHeader();
initReveal();
initImages();
initButtons();
initTilt();
initParallax();
Cart.init();
initProduct();
if (!reduced()) {
var delay = root.classList.contains('sc-intro-on') ? 1700 : 300;
setTimeout(function () { if ('requestIdleCallback' in window) requestIdleCallback(snow.start, { timeout: 800 }); else snow.start(); }, delay);
}
$$('[data-sc-motion-toggle]').forEach(function (b) {
b.addEventListener('click', function () {
var off = !root.classList.contains('sc-no-motion');
root.classList.toggle('sc-no-motion', off);
store('sc_motion', off ? 'off' : 'on');
if (off) { snow.stop(); $$('[data-sc-reveal], [data-sc-split], [data-sc-unmask]').forEach(function (e) { e.classList.add('is-in'); }); }
else snow.start();
syncMotionToggles();
});
});
if (reduceMQ.addEventListener) reduceMQ.addEventListener('change', function () { if (reduced()) snow.stop(); else snow.start(); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
